import PropTypes    from 'prop-types';
import _            from 'underscore';
import randomString from '../utils/randomString';

const serviceSubjectShape = {
  '@id':   PropTypes.string.isRequired,
  '@type': PropTypes.string.isRequired,
  id:      PropTypes.string.isRequired,
  name:    PropTypes.string.isRequired,
  slug:    PropTypes.string.isRequired,
};

const serviceSubjectPropType = PropTypes.shape(serviceSubjectShape);

const generateMockServiceSubject = () => {

  const id = randomString(32);

  const slug = randomString(32);

  return {
    '@id':          '/services/' + id,
    '@type':        'http://schema.org/Thing',
    'id':           id,
    'name':         slug[0].toUpperCase() + slug.slice(1),
    'slug':         slug,
    'serviceCount': _.random(0, 25),
  };

};

export {
  serviceSubjectShape,
  serviceSubjectPropType,
  generateMockServiceSubject
};


// WEBPACK FOOTER //
// ./src/domain/serviceSubject.js